import HeroBanner from "../components/landing/Hero";
import { lazy, Suspense, useEffect } from "react";
import {
  setCanonicalUrl,
  setJsonLd,
  setMetaTag,
  setPropertyMetaTag,
  SITE_URL,
} from "../helpers/seoUtils";
import useAnalytics from "../hooks/useAnalytics";

const AboutUs = lazy(() =>
  import("../components/landing/AboutUs").then((module) => ({
    default: module.AboutUs,
  })),
);
const Partners = lazy(() => import("../components/landing/Partners"));
const Offers = lazy(() => import("../components/landing/Offers"));
const Gallery = lazy(() => import("../components/landing/Gallery"));
const LatestNews = lazy(() => import("../components/landing/LatestNews"));

const HomePage = () => {
  useEffect(() => {
    document.title = "Economus – Playgrounds in Lithuania";
    setCanonicalUrl("/");

    setMetaTag(
      "description",
      "Economus specializes in safe, modern children’s playgrounds in Lithuania. We turn vision into reality with certified equipment and coatings.",
    );
    setMetaTag(
      "keywords",
      "playgrounds, playgrounds in Lithuania, children’s playgrounds, Economus, vaikų žaidimų aikštelės, žaidimų aikštelės Lietuvoje, saugios aikštelės",
    );

    setPropertyMetaTag("og:title", "Economus – Playgrounds in Lithuania");
    setPropertyMetaTag(
      "og:description",
      "Safe and certified children's playgrounds and coatings. Based in Lithuania.",
    );
    setPropertyMetaTag(
      "og:image",
      "https://economus.lt/static/media/playground-1.2ce91d1e3b0027d15c26.webp",
    );
    setPropertyMetaTag("og:url", `${SITE_URL}/`);
    setPropertyMetaTag("og:type", "website");

    setMetaTag("twitter:card", "summary_large_image");
    setMetaTag("twitter:title", "Economus – Playgrounds in Lithuania");
    setMetaTag(
      "twitter:description",
      "Safe and certified children's playgrounds and coatings.",
    );
    setMetaTag(
      "twitter:image",
      "https://economus.lt/static/media/playground-1.2ce91d1e3b0027d15c26.webp",
    );

    setMetaTag("language", "lt");
    setMetaTag("geo.region", "LT");
    setMetaTag("geo.placename", "Lithuania");
    setMetaTag("robots", "index, follow");
    setJsonLd("website", {
      "@context": "https://schema.org",
      "@type": "WebSite",
      name: "Economus",
      url: SITE_URL,
      inLanguage: "lt-LT",
      potentialAction: {
        "@type": "SearchAction",
        target: `${SITE_URL}/el-parduotuve?search={search_term_string}`,
        "query-input": "required name=search_term_string",
      },
    });
  }, []);

  useAnalytics({ page: "home" });

  return (
    <>
      <HeroBanner />
      <Suspense fallback={<div className="h-[40vh]" />}>
        <AboutUs />
      </Suspense>
      <Suspense fallback={<div className="h-[24vh]" />}>
        <Partners />
      </Suspense>
      <Suspense fallback={<div className="h-[36vh]" />}>
        <Offers />
      </Suspense>
      <Suspense fallback={<div className="h-[36vh]" />}>
        <Gallery />
      </Suspense>
      <Suspense fallback={<div className="h-[36vh]" />}>
        <LatestNews />
      </Suspense>
    </>
  );
};

export default HomePage;
